export default __webpack_public_path__ + "static/media/1298.fe6ec7e3.png";